import { axiosInstance } from 'src/services/axios-instance'

export const downloadSire = (sireData: any[], fileName = 'sire_data.txt') => {
  if (!sireData || sireData.length === 0) {
    console.warn('No SIRE data to download.')
    return
  }

  const tsvContent = sireData
    .map((row) =>
      Array.isArray(row)
        ? row.map((item) => (item !== null && item !== undefined ? item : '')).join('\t')
        : '',
    )
    .join('\n')

  const blob = new Blob([tsvContent], { type: 'text/tab-separated-values;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Fetch the guest's SIRE rows from the server (they are not part of the guest
 * payload: PIN-protected surveys withhold them) and download the file.
 */
export const downloadSireForGuest = async (guestId: string, fileName?: string) => {
  const res = await axiosInstance.get<{ sire_data: any[] }>(
    `/stays/reservation-guests/${guestId}/sire-download/`,
  )
  downloadSire(res.data.sire_data, fileName)
}

export const downloadReceipt = async (guestId: string, system: string) => {
  const res = await axiosInstance.get(`/stays/reservation-guests/${guestId}/receipt/${system}/`, {
    responseType: 'blob',
  })
  const url = URL.createObjectURL(res.data)
  const link = document.createElement('a')
  link.href = url
  link.download = `${system}-receipt.pdf`
  link.click()
  URL.revokeObjectURL(url)
}

export const downloadReport = (url: string) => {
  const link = document.createElement('a')
  link.setAttribute('target', '_blank')
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Download a remote file via an anchor tag. For same-origin assets the browser
 * downloads directly; for cross-origin assets (e.g. S3) the `download` hint is
 * ignored and the file opens in a new tab — the `target`/`rel` keep that safe.
 */
export const downloadFile = (url: string, filename?: string) => {
  const link = document.createElement('a')
  link.href = url
  if (filename) link.setAttribute('download', filename)
  link.setAttribute('target', '_blank')
  link.setAttribute('rel', 'noopener')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
